<template>
    <div>
        <tim
    </div>
</template>
<script>
    export default {
        name: 'collection-grid',
        data() {
            return {}
        }
    }
</script>